import * as React from 'react';
import styled from 'styled-components';

import { IconSystemV2CourseBookAccess } from '@doltech/icons/SystemV2/IconSystemV2CourseBookAccess';
import { IconSystemV2StatusCheck2 } from '@doltech/icons/SystemV2/IconSystemV2StatusCheck2';

import { colorsV2 } from '../../colors-v2';
import { ResponsiveTypography } from '../../Typography/v3/ResponsiveTypography';
import { ButtonGeneral } from '../../Button/ButtonGeneral/ButtonGeneral';

const Alert = styled.div`
  display: flex;
  align-items: center;

  padding: 12px 16px;
  border-radius: 8px;

  &.done {
    background-color: ${colorsV2.blue10};
    color: ${colorsV2.blue100};
  }

  &.done-correct-all {
    background-color: ${colorsV2.green10};
    color: ${colorsV2.green100};
  }
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: [first] minmax(0, 1fr) [second] auto [last];
  column-gap: 12px;

  .action-button {
    grid-column: second / last;
  }
`;

interface QuizBoxItemButtonSingleQuizProps {
  status?: 'default' | 'done' | 'done-correct-all';
  alertText?: string;
  onCheckAnswer?: () => void;
  onRedo?: () => void;
  disabled?: boolean;
}

export const QuizBoxItemButtonSingleQuiz = (props: QuizBoxItemButtonSingleQuizProps) => {
  const { status, alertText, onCheckAnswer, onRedo, disabled = false } = props;

  switch (status) {
    case 'done-correct-all':
      return (
        <Container className="quiz-box-item-button-single-quiz">
          <Alert className="alert-box done-correct-all">
            <IconSystemV2StatusCheck2 size={20} mr="10px" />
            <ResponsiveTypography.Paragraph variant="semi-bold/16-24">
              {alertText}
            </ResponsiveTypography.Paragraph>
          </Alert>
          <ButtonGeneral className="action-button" type="tertiary" size="x-large" text="Do it again" onClick={onRedo} />
        </Container>
      );
    case 'done':
      return (
        <Container className="quiz-box-item-button-single-quiz">
          <Alert className="alert-box done">
            <IconSystemV2CourseBookAccess size={20} mr="10px" />
            <ResponsiveTypography.Paragraph variant="semi-bold/16-24">
              {alertText}
            </ResponsiveTypography.Paragraph>
          </Alert>
          <ButtonGeneral className="action-button" type="tertiary" size="x-large" text="Do it again" onClick={onRedo} />
        </Container>
      );
    case 'default':
    default:
  }

  return (
    <Container className="quiz-box-item-button-single-quiz">
      <ButtonGeneral className="action-button" type="primary" size="x-large" text="Check answer" onClick={onCheckAnswer} disabled={disabled} transparent={disabled} />
    </Container>
  );
};
